import {
    CASHIN_NOT_FOUND,
    CASHIN_CARD_NOT_FOUND,
    CASHIN_FAILED,
    CASHIN_INVALID_REQUEST,
    CASHIN_INSUFFICIENT_BALANCE,
    CASHIN_SUCCESS,
    CASHIN_AUTHENTICATION_FAILED,
    CASHIN_INVALID_CURRENCY,
    CASHIN_ACCOUNT_NOT_EXISTS,
    CASHIN_INVALID_WALLET_OWNER_ID,
    CASHIN_INVALID_ACCOUNTTYPE,
    CASHIN_OPERATION_NOT_PERMITTED,
    RESET_CASHIN,
    LOADING_CASHIN
} from "../types";

const initialState = {
    isLoading: false,
    notFound: false,
    failed: false,
    invalidRequest: false,
    cardNotFound: false,
    success: false,
    insufficientBalance: false,
    authenticationFailed: false,
    invalidCurrency: false,
    accountNotExist: false,
    invalidWalletOwnerId: false,
    invalidAccounttype: false,
    operationNotPermitted: false,
    data: {},
    status: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CASHIN:
            return {
                ...state,
                isLoading: true,
                notFound: false,
                failed: false,
                invalidRequest: false,
                cardNotFound: false,
                success: false,
                insufficientBalance: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: {},
                status: ""
            };
        case CASHIN_NOT_FOUND:
            return {
                ...state,
                isLoading: false,
                notFound: true,
                success: false,
                invalidRequest: false,
                failed: false,
                cardNotFound: false,
                insufficientBalance: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                status: "User not found!",
                data: action.payload
            };

        case CASHIN_INSUFFICIENT_BALANCE:
            return {
                ...state,
                isLoading: false,
                notFound: false,
                success: false,
                invalidRequest: false,
                failed: false,
                cardNotFound: false,
                insufficientBalance: true,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                status: "Insufficient Balance",
                data: action.payload
            };
        case CASHIN_CARD_NOT_FOUND:
            return {
                ...state,
                isLoading: false,
                cardNotFound: true,
                success: false,
                notFound: false,
                invalidRequest: false,
                insufficientBalance: false,
                failed: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: action.payload,
                status: "Card not found!",
            };
        case CASHIN_FAILED:
            return {
                ...state,
                isLoading: false,
                failed: true,
                notFound: false,
                success: false,
                invalidRequest: false,
                insufficientBalance: false,
                cardNotFound: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: action.payload,
                status: "Transfer failed!",
            };
        case CASHIN_INVALID_REQUEST:
            return {
                ...state,
                isLoading: false,
                invalidRequest: true,
                failed: false,
                insufficientBalance: false,
                success: false,
                notFound: false,
                cardNotFound: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: action.payload,
                status: "Oops!, Something went wrong",
            };
        case CASHIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                notFound: false,
                invalidRequest: false,
                insufficientBalance: false,
                failed: false,
                cardNotFound: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: action.payload,
                status: ""
            };
        case CASHIN_AUTHENTICATION_FAILED:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: false,
                success: false,
                invalidRequest: false,
                insufficientBalance: false,
                cardNotFound: false,
                authenticationFailed: true,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: action.payload,
                status: "User Authentication Failed"
            };
        case CASHIN_INVALID_CURRENCY:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: false,
                success: false,
                invalidRequest: false,
                insufficientBalance: false,
                cardNotFound: false,
                authenticationFailed: false,
                invalidCurrency: true,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: action.payload,
                status: "Invalid Currency"
            };
        case CASHIN_ACCOUNT_NOT_EXISTS:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: false,
                success: false,
                invalidRequest: false,
                insufficientBalance: false,
                cardNotFound: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: true,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: action.payload,
                status: "Account Does Not Exist"
            };
        case CASHIN_INVALID_WALLET_OWNER_ID:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: false,
                success: false,
                invalidRequest: false,
                insufficientBalance: false,
                cardNotFound: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: true,
                invalidAccounttype: false,
                operationNotPermitted: false,
                data: action.payload,
                status: "Invalid Wallet Owner ID"
            };
        case CASHIN_INVALID_ACCOUNTTYPE:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: false,
                success: false,
                invalidRequest: false,
                insufficientBalance: false,
                cardNotFound: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: true,
                operationNotPermitted: false,
                data: action.payload,
                status: "Provide valid Merchant's or Agent's mobile number."
            };

        case CASHIN_OPERATION_NOT_PERMITTED:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: false,
                success: false,
                invalidRequest: false,
                insufficientBalance: false,
                cardNotFound: false,
                authenticationFailed: false,
                invalidCurrency: false,
                accountNotExist: false,
                invalidWalletOwnerId: false,
                invalidAccounttype: false,
                operationNotPermitted: true,
                data: action.payload,
                status: "Operation Not Permitted"
            };

        case RESET_CASHIN:
            return (state = initialState);

        default:
            return state;
    }
};